import {
  Box,
  Button,
  Container,
  createStyles,
  Text,
  Accordion,
  Table,
  Menu,
  ActionIcon,
  ScrollArea,
  Center,
  Checkbox,
  Paper,
  Tooltip,
  Mark,
  Badge,
  Stack,
  Group,
  Grid,
  Title,
  Select,
  Switch,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import "./style.css";
import AddProvider from "../../../components/ClaimBilling/AddProvider";
import AddClient from "../../../components/ClaimBilling/AddClient";
import AddPayer from "../../../components/ClaimBilling/AddPayer";
import { getProccode, getServicecode } from "../../../services/servicecode";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import {
  createpayer,
  getpayer,
  getpayerlist,
  removepayer,
} from "../../../services/payer";
import { useSelector } from "react-redux";
import EditPayer from "../../../components/ClaimBilling/AddPayer";
import EditProvider from "../../../components/ClaimBilling/AddProvider";
import {
  AddBillingCache,
  createBilling,
  getAllBillingModal,
  getAllFacilitiesModal,
} from "../../../services";
import { decrypt, encrypt } from "../../../utils";
import {
  getBillingProvider,
  removeProvider,
} from "../../../services/billingprovider";
import TableLoader from "../../../components/TableLoader";

import RecordNotFound from "../../../components/RecordNotFound";
import { IconEye, IconTrash, IconPlus, IconBulb, IconCreditCard } from "@tabler/icons-react";
import { IconEdit, IconClipboardCheck } from "@tabler/icons-react";
import { BiDotsVerticalRounded, BiChevronDown } from "react-icons/bi";
import { IoCloseOutline } from "react-icons/io5";
import EditClient from "../../../components/ClaimBilling/AddClient";
import SettingDrawer from "../../../components/BillingInvoices/InvoiceSetting/SettingDrawer";
import AddBillingDate from "../../../components/ClaimBilling/AddBillingDate";
import ViewClientClaimServices from "../../../components/ClaimBilling/ViewClientClaimServices";
import BillingSearchAll from "../../../components/Document/BilllingSearchAll";
import CustomBillingPagination from "../../../components/Pagination/CustomBillingPagination";
import { getAllPatients } from "../../../services/patient";
import { updateProfile, getProfile } from "../../../services/profile";
import ProviderEnrollment from "../../../components/ClaimBilling/ProviderEnrollment";
import VerifyEligibilityModal from "../../../components/ClaimBilling/VerifyEligibilityModal";

const useStyles = createStyles(() => ({
  drawer: {
    ".mantine-Drawer-content": {
      backgroundColor: "#f5f5f5",
    },
  },

  bg1: {
    "& td": {
      background: "#fff",
    },
  },
  bg2: {
    "& td": {
      background: "#F9FAFB",
    },
  },

  tableRoot: {
    "tbody tr:hover td": {
      backgroundColor: "#FFF6ED !important",
    },
  },

  selected: {
    "& td": {
      background: "#FFF6ED",
    },
  },

  wizardStepTitle: {
    margin: "0 0 6px",
    fontSize: "26px",
    fontWeight: 700,
    color: "#171717",
    letterSpacing: "-0.022em",
    fontFamily: "Inter",
  },

  wizardStepDesc: {
    margin: "0 0 22px",
    fontSize: "14.5px",
    color: "#667085",
    lineHeight: 1.6,
    maxWidth: "720px",
    fontFamily: "Inter",
  },

  wizardCard: {
    background: "#fff",
    border: "1px solid #E5E5E5",
    borderRadius: "14px",
    padding: "24px 26px",
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  },

  tipBanner: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    background: "#FFF4DA",
    border: "1px solid #FAE7BE",
    borderRadius: "10px",
    padding: "12px 14px",
    marginBottom: "18px",
    fontSize: "13px",
    color: "#78350F",
    fontFamily: "Inter",
    lineHeight: 1.55,
    "& b, & strong": {
      color: "#92400E",
    },
  },

  tipIcon: {
    color: "#B7791F",
    flexShrink: 0,
    marginTop: "2px",
  },

  wizardCardHeadRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "14px",
  },

  wizardCardTitle: {
    margin: 0,
    fontSize: "14.5px",
    fontWeight: 700,
    color: "#171717",
    fontFamily: "Inter",
  },

  wizardCardMeta: {
    margin: "2px 0 0",
    fontSize: "12.5px",
    color: "#667085",
    fontFamily: "Inter",
  },

  payerList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  payerAddBar: {
    display: "flex",
    gap: "10px",
    marginBottom: "16px",
    alignItems: "stretch",
    marginTop: "20px",
  },

  addAccentBtn: {
    height: "48px",
    padding: "0 18px",
    borderRadius: "10px",
    background: "#F5A623",
    color: "#171717",
    border: 0,
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    whiteSpace: "nowrap",
    transition: "background .12s ease",
    "&:hover": {
      background: "#E09610",
    },
  },

  payerActionPrimary: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "6px 8px",
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 600,
    color: "#B45309",
    background: "transparent",
    border: 0,
    borderRadius: "6px",
    cursor: "pointer",
    "&:hover": {
      background: "#FFF4DA",
      color: "#B45309",
    },
  },

  linkBtnPurple: {
    background: "transparent",
    border: 0,
    padding: 0,
    fontFamily: "Inter, sans-serif",
    fontSize: "13px",
    fontWeight: 600,
    color: "#6D5BB0",
    cursor: "pointer",
    textDecoration: "underline",
    textUnderlineOffset: "3px",
    textDecorationThickness: "1.5px",
    textDecorationColor: "#BFB1E5",
    whiteSpace: "nowrap",
    "&:hover": {
      color: "#4F3F8E",
      textDecorationColor: "#6D5BB0",
    },
  },

  payerRow: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    padding: "14px 16px",
    border: "1px solid #E5E5E5",
    borderRadius: "8px",
    background: "#fff",
    flexWrap: "wrap",
    transition: "background .12s ease",
    "&:hover": {
      background: "#FAFAFA",
    },
  },

  payerRowSelected: {
    background: "#FFF4DA !important",
    borderColor: "#F5C518 !important",
    "&:hover": {
      background: "#FFF4DA !important",
    },
  },

  payerRowInfo: {
    flex: 1,
    minWidth: "240px",
  },

  payerTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  },

  payerRowH5: {
    margin: 0,
    fontSize: "14px",
    fontWeight: 600,
    color: "#171717",
    fontFamily: "Inter",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
  },

  statusInline: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "12px",
    fontWeight: 500,
    color: "#667085",
    whiteSpace: "nowrap",
    fontFamily: "Inter",
  },

  statusDot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    background: "#667085",
    flexShrink: 0,
  },

  payerRowP: {
    margin: "4px 0 0",
    fontSize: "12px",
    color: "#667085",
    fontFamily: "Inter",
    lineHeight: 1.5,
  },

  payerRowActions: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    flexShrink: 0,
  },

  payerAction: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "6px 8px",
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 600,
    color: "#52525B",
    background: "transparent",
    border: 0,
    borderRadius: "6px",
    cursor: "pointer",
    "&:hover": {
      background: "#F4F4F5",
      color: "#171717",
    },
  },

  payerDeleteBtn: {
    width: "30px",
    height: "30px",
    borderRadius: "6px",
    background: "transparent",
    border: 0,
    color: "#667085",
    cursor: "pointer",
    display: "grid",
    placeItems: "center",
    marginLeft: "2px",
    "&:hover": {
      background: "#FEF2F2",
      color: "#B91C1C",
    },
    "& svg": {
      width: "15px",
      height: "15px",
    },
  },

  clientRow: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    padding: "14px 16px",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    background: "#fff",
    marginBottom: "8px",
    "&:last-child": {
      marginBottom: 0,
    },
  },

  clientRowSelected: {
    border: "1px solid #F59E0B",
    background: "#FFFBEB",
  },

  clientRowInfo: {
    flex: 1,
    minWidth: 0,
  },

  clientTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "4px",
    "& h5": {
      margin: 0,
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 600,
      color: "#171717",
      display: "flex",
      alignItems: "center",
    },
  },

  linkedPayerTag: {
    display: "inline-flex",
    alignItems: "center",
    padding: "2px 7px",
    borderRadius: "999px",
    background: "#F1EEFB",
    border: "1px solid #D7CDF0",
    color: "#6D5BB0",
    fontSize: "9.5px",
    fontWeight: 700,
    fontFamily: "Inter",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    flexShrink: 0,
  },

  clientMeta: {
    margin: "0 0 8px 0",
    fontFamily: "Inter",
    fontSize: "12px",
    color: "#737373",
    fontWeight: 400,
  },

  clientPayerInfo: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px 14px",
    alignItems: "center",
    marginTop: "6px",
    fontSize: "12px",
    color: "#262626",
  },

  clientFieldChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    fontFamily: "Inter",
  },

  clientFieldChipKey: {
    fontSize: "10.5px",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    color: "#667085",
  },

  clientFieldChipVal: {
    fontWeight: 500,
    color: "#171717",
  },

  clientWarningIcon: {
    marginLeft: "6px",
    verticalAlign: "middle",
  },

  clientRowActions: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    flexShrink: 0,
  },

  clientViewBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "6px 8px",
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 600,
    color: "#52525B",
    background: "transparent",
    border: 0,
    borderRadius: "6px",
    cursor: "pointer",
    "&:hover": {
      background: "#F4F4F5",
      color: "#171717",
    },
  },

  verifyEligBtn: {
    background: "transparent",
    border: 0,
    padding: 0,
    fontFamily: "Inter, sans-serif",
    fontSize: "13px",
    fontWeight: 600,
    color: "#B7791F",
    cursor: "pointer",
    textDecoration: "underline",
    textUnderlineOffset: "3px",
    textDecorationThickness: "1.5px",
    textDecorationColor: "#FAE7BE",
    whiteSpace: "nowrap",
    "&:hover": {
      color: "#6B4C0A",
      textDecorationColor: "#FFBA45",
    },
  },

  prefSectionLabel: {
    margin: "0 0 14px 0",
    fontFamily: "Inter",
    fontSize: "10.5px",
    fontWeight: 700,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    color: "#667085",
  },

  prefSectionLabelSpaced: {
    margin: "24px 0 14px 0",
    fontFamily: "Inter",
    fontSize: "10.5px",
    fontWeight: 700,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    color: "#667085",
  },

  prefFormGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "16px 18px",
    marginBottom: "0",
  },

  prefField: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },

  prefFieldLabel: {
    fontFamily: "Inter",
    fontSize: "12.5px",
    fontWeight: 600,
    color: "#344054",
    margin: 0,
  },

  prefSelectWrapper: {
    width: "100%",
  },

  prefSelectInput: {
    height: "42px",
    border: "1px solid #E5E5E5",
    borderRadius: "8px",
    fontFamily: "Inter",
    fontSize: "13px",
    color: "#171717",
    background: "#fff",
    "&:focus": {
      borderColor: "#FFBA45",
    },
  },

  prefSelectChevron: {
    fontSize: "14px",
    color: "#667085",
  },

  prefSwitchTrack: {
    background: "#D4D4D8 !important",
    borderColor: "#D4D4D8 !important",
  },

  prefSwitchRoot: {
    "& input:checked + label": {
      background: "#171717 !important",
      borderColor: "#171717 !important",
    },
  },

  prefSwitchThumb: {
    background: "#fff",
    border: "none",
  },

  prefRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "14px 0",
    borderBottom: "1px solid #F3F3F3",
    gap: "16px",
    "&:last-child": {
      borderBottom: 0,
    },
  },

  prefRowInfo: {
    flex: 1,
    minWidth: 0,
  },

  prefRowTitle: {
    margin: 0,
    fontFamily: "Inter",
    fontSize: "13.5px",
    fontWeight: 600,
    color: "#171717",
  },

  prefRowDesc: {
    margin: "2px 0 0",
    fontFamily: "Inter",
    fontSize: "12.5px",
    color: "#667085",
    lineHeight: 1.5,
  },

  notFoundText: {
    color: "#A8A8A8",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
    justifyContent: "center",
  },

  mainContainer: {
    background: "#f5f5f5",
    display: "flex",
    borderRadius: "16px",
    border: "1px solid #E5E5E5",
    backgroundColor: "#FFF",
    width: "100%",
    margin: "auto",
    marginTop: "20px",
    "@media (max-width:800px)": {
      width: "90%",
    },
    "@media (max-width:500px)": {
      width: "100%",
    },
  },

  searchbox: {
    width: "100% !important",
    marginBottom: "10px",
  },

  flexend: {
    display: "flex",
    justifyContent: "flex-end",
  },

  wizardFooter: {
    background: "#fff",
    borderTop: "1px solid #E5E5E5",
    padding: "14px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
  },

  wizardFooterNote: {
    fontSize: "12.5px",
    color: "#667085",
    fontFamily: "Inter",
  },

  wizardFooterRight: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },

  backBtn: {
    background: "transparent",
    border: "1px solid #E5E5E5",
    borderRadius: "8px",
    padding: "0 16px",
    height: "38px",
    fontSize: "14px",
    fontWeight: 500,
    color: "#374151",
    cursor: "pointer",
    fontFamily: "Inter",
    display: "inline-flex",
    alignItems: "center",
    "&:hover": {
      background: "#F3F4F6",
    },
  },

  flexFill: {
    flex: 1,
  },

  emptyBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "240px",
    gap: "1rem",
  },

  wizardCardSpaced: {
    marginBottom: "12px",
  },

  tableInterFont: {
    fontFamily: "Inter",
  },

  scrollAreaMin: {
    minHeight: "300px",
  },

  enrolledDisabled: {
    opacity: 0.5,
    cursor: "not-allowed",
  },

  suggestionboxSpaced: {
    marginTop: "26px",
  },

  tabs: {
    width: "100%",
    background: "#FFF",
    borderRadius: "12px",
    padding: "16px 16px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    marginBottom: "0",
  },

  subnavSpacer: {
    flex: 1,
  },

  displaybox: {
    display: "flex",
    alignItems: "center",
    gap: "0",
  },

  reviewpad: {
    padding: "0",
  },

  reviewHeadingBox: {
    padding: "0px 0px",
    "& h3": {
      fontSize: "26px",
      fontWeight: "700",
      fontFamily: "Inter",
      color: "#171717",
      margin: 0,
    },
    "& p": {
      fontSize: "14px",
      fontWeight: "400",
      color: "#667085",
      fontFamily: "Inter",
      margin: 0,
    },
  },

  tabbtn: {
    color: "#000",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "20px",
  },

  claimtype: {
    color: "#FFAF4A",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "20px",
  },

  tabsinner: {
    display: "inline-flex",
    alignItems: "center",
    padding: "8px 16px",
    fontFamily: "Inter, inherit",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    color: "#000",
    background: "transparent",
    border: "none",
    borderBottom: "2px solid transparent",
    borderRadius: "4px 4px 0 0",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "border-color .12s ease",
    "&:hover": {
      borderBottomColor: "rgba(0,0,0,0.15)",
    },
  },

  tabsinnerActive: {
    borderBottomColor: "#171717",
    background: "#FFF",
  },

  tabsinnerDisabled: {
    color: "#9CA3AF",
    cursor: "not-allowed",
    pointerEvents: "none",
    borderBottomColor: "transparent",
  },

  tabsinnerIcon: {
    padding: "8px 10px",
    borderRadius: "8px",
    color: "#667085",
    background: "transparent",
    borderBottom: "none",
    "&:hover": {
      color: "#171717",
      background: "transparent",
      borderBottomColor: "transparent",
    },
  },

  button: {
    "&:hover": {
      background: "#FFAF4A",
      color: "#FFFFFF",
      opacity: 0.8,
    },
  },

  mainbillingbox: {
    width: "100%",
  },

  mainbillingcontainer: {
    flex: 1,
    overflowY: "auto",
    padding: "36px 24px",
    "@media (max-width:900px)": {
      padding: "24px 16px",
    },
  },

  wizardContent: {
    maxWidth: "920px",
    margin: "0 auto",
  },

  clientInfoCardDataParent: {
    display: "flex",
    justifyContent: "space-between",
    gap: "24px",
    "@media (max-width:1300px)": {
      gap: "10px",
    },
  },

  container: {
    display: "flex",
    flexDirection: "column",
    gap: ".5rem",
    padding: "12px 8px",
  },
  userDetails: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "1rem",
    borderColor: "#E5E5EA",
    borderWidth: "2px",
    borderStyle: "solid",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  details: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  noteDetails: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  noteContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: ".5rem",
  },
  item: {
    borderRadius: "8px",
    marginBottom: "8px",
    overflow: "hidden",
    background: "#fff",
  },
  outcomeBox: {
    display: "flex",
    gap: "1rem",
    backgroundColor: "#FAFAFA",
    padding: "1rem",
    borderRadius: "10px",
    border: "1px solid #E7EBEF",
    marginBottom: "1rem",
    marginTop: "1rem",
  },
  coutcomeItem: {
    display: "flex",
    gap: ".4rem",
    flex: "1",
    flexDirection: "column",
  },
  outcomeNote: {
    backgroundColor: "#FAFAFA",
    borderRadius: "10px",
    padding: "1rem",
    borderColor: "#E5E5E5",
    borderWidth: "2px",
    borderStyle: "solid",
    marginTop: "1rem",
  },

  btns: {
    display: "flex",
    gap: "1rem",
    justifyContent: "flex-end",
    gap: "4px",
    marginTop: "12rem",
  },

  backbtn: {
    borderRadius: "8px",
    border: "1px solid #F5F5F5",
    background: "#F5F5F5",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
  },

  mainbox: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    width: "50%",
    margin: "auto",
    "@media (max-width:1100px)": {
      width: "85%",
    },
  },

  text: {
    marginTop: "5px",
    marginLeft: "-21px",
    "@media (max-width:500px)": {
      fontSize: "14px",
    },
  },

  beginbilling: {
    textAlign: "center",
    alignItems: "center",
    marginTop: "39px",
    cursor: "pointer",
  },

  suggestionbox: {
    marginBottom: "15px",
  },

  suggestionminibox: {
    display: "flex",
    gap: "10px",
    height: "52px",
    alignItems: "center",
    padding: "4px 12px",
    borderRadius: "8px",
    border: "1px solid #E4E4E7",
    background: "#FFF",
  },

  mt: {
    marginTop: "20px",
  },

  accordionbox: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },

  box: {
    width: "30px",
    height: "30px",
    border: "1px solid #000",
    background: "#D9D9D9",
    color: "#FFF",
  },

  cp: {
    cursor: "pointer",
  },

  btnflex: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px",
  },

  addbtn: {
    marginTop: "44px",
    marginBottom: "4px",
    display: "flex",
    justifyContent: "flex-end",
  },
  stepNumberText: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  checkbox: {
    width: "20px",
    height: "20px",
    marginRight: "10px",
  },

  selectbox: {
    background: "#FFF",
    borderBottom: "1px solid #E5E5E5",
    padding: "18px 24px",
    flexShrink: 0,
    display: "flex",
    justifyContent: "center",
    position: "sticky",
    top: 0,
    zIndex: 5,
  },

  insidebox: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    maxWidth: "1100px",
    flexWrap: "nowrap",
    overflowX: "auto",
  },

  iconbox: {
    display: "inline-flex",
    alignItems: "center",
    gap: "10px",
    padding: "4px",
    flexShrink: 0,
    cursor: "pointer",
  },

  stepNum: {
    width: "30px",
    height: "30px",
    borderRadius: "999px",
    background: "#fff",
    border: "1.5px solid #E5E5E5",
    color: "#667085",
    display: "grid",
    placeItems: "center",
    fontSize: "12.5px",
    fontWeight: 700,
    flexShrink: 0,
    lineHeight: 1,
  },

  stepNumDone: {
    background: "#171717",
    borderColor: "#171717",
    color: "#fff",
  },

  stepNumCurrent: {
    background: "#FFBA45",
    borderColor: "#FFBA45",
    color: "#171717",
    boxShadow: "0 0 0 4px #FFF4DA",
  },

  stepLabel: {
    fontSize: "12.5px",
    fontWeight: 600,
    color: "#667085",
    whiteSpace: "nowrap",
  },

  stepLabelDone: {
    color: "#262626",
  },

  stepLabelCurrent: {
    color: "#171717",
  },

  stepSep: {
    flexShrink: 0,
    width: "28px",
    height: "1.5px",
    background: "#E5E5E5",
    borderRadius: "2px",
  },

  stepSepDone: {
    background: "#171717",
  },

  newbeginbilling: {},
  newborder: {},

  border: {
    width: "104px",
    borderRadius: "4px 4px 0px 0px",
    borderBottom: "3px solid #171717",
  },

  back: {
    marginTop: "21px",
    marginBottom: "27px",
    display: "flex",
    gap: "1px",
    cursor: "pointer",
  },
  header: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: "700",
    color: "#000",
  },

  row: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: "400",
    color: "#000",
  },

  claimreviewbox: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "40px",
  },

  viewheaders: {
    color: "#737373 !important",
    fontSize: "12px !important",
    fontWeight: "400 !important",
    fontFamily: "Inter !important",
  },

  viewpara: {
    color: "#262626 !important",
    fontSize: "20px !important",
    fontWeight: "500 !important",
    fontFamily: "Inter !important",
  },

  alertbox: {
    marginTop: "40px",
    marginBottom: "40px",
    display: "flex",
    gap: "8px",
    padding: "4px 10px 4px 4px",
    width: "100%",
    borderRadius: "16px",
    background: "#FEF3F2",
    mixBlendMode: "multiply",
  },

  noticebox: {
    marginTop: "40px",
    marginBottom: "40px",
    display: "flex",
    gap: "8px",
    padding: "4px 10px 4px 4px",
    width: "100%",
    borderRadius: "16px",
    background: "#FFFAEB",
    mixBlendMode: "multiply",
  },

  reviewClaim: {
    background: "#fff",
    border: "1px solid #E5E5E5",
    borderRadius: "14px",
    padding: "24px 26px",
    boxShadow: "0 1px 2px rgba(16, 24, 40, 0.04)",
  },

  reviewHead: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "24px",
    paddingBottom: "18px",
    borderBottom: "1px solid #F1F1F1",
    flexWrap: "wrap",
    "& .review-left h3": {
      margin: "0 0 2px",
      fontSize: "22px",
      fontWeight: "700",
      color: "#171717",
      letterSpacing: "-0.018em",
      fontFamily: "Inter",
    },
    "& .review-left p": {
      margin: 0,
      fontSize: "13px",
      color: "#667085",
      fontFamily: "Inter",
    },
    "& .review-right": {
      textAlign: "right",
    },
    "& .review-right .rlabel": {
      fontSize: "12px",
      color: "#667085",
      fontFamily: "Inter",
    },
    "& .review-right .rval": {
      fontSize: "24px",
      fontWeight: "700",
      color: "#171717",
      letterSpacing: "-0.022em",
      marginTop: "2px",
      fontFamily: "Inter",
    },
    "& .review-right .rmeta": {
      fontSize: "12px",
      color: "#667085",
      marginTop: "4px",
      fontFamily: "Inter",
    },
  },

  reviewMetaRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "32px",
    padding: "18px 0",
    borderBottom: "1px solid #F1F1F1",
    "& .kv": {
      minWidth: "150px",
    },
    "& .kv .k": {
      fontSize: "11.5px",
      color: "#667085",
      fontWeight: "500",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontFamily: "Inter",
    },
    "& .kv .v": {
      fontSize: "14px",
      color: "#171717",
      fontWeight: "600",
      marginTop: "2px",
      fontFamily: "Inter",
    },
  },

  reviewClients: {
    paddingTop: "14px",
    "& .clients-heading": {
      margin: "4px 0 8px",
      fontSize: "11.5px",
      fontWeight: "700",
      color: "#667085",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      fontFamily: "Inter",
    },
  },

  reviewClientRow: {
    display: "grid",
    gridTemplateColumns: "1.5fr 1fr 1fr auto",
    gap: "16px",
    alignItems: "center",
    padding: "12px 0",
    borderBottom: "1px solid #F1F1F1",
    "&:last-child": {
      borderBottom: "none",
    },
    "& .label": {
      fontSize: "11.5px",
      color: "#667085",
      fontWeight: "500",
      fontFamily: "Inter",
    },
    "& .v": {
      fontSize: "13.5px",
      color: "#171717",
      fontWeight: "600",
      marginTop: "2px",
      fontFamily: "Inter",
    },
  },

  reviewViewBtn: {
    fontSize: "12px",
    fontWeight: "500",
    fontFamily: "Inter",
    padding: "4px 12px",
    borderRadius: "6px",
    background: "transparent",
    color: "#374151",
    border: "1px solid #D1D5DB",
    cursor: "pointer",
    "&:hover": {
      background: "#F9FAFB",
    },
  },

  reviewEmptyState: {
    padding: "40px 0",
    textAlign: "center",
    color: "#667085",
    fontFamily: "Inter",
    fontSize: "14px",
  },

  wizardOverlay: {
    position: "fixed",
    inset: 0,
    zIndex: 10,
    background: "#F5F5F5",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },

  wizardHeaderBar: {
    background: "#171717",
    padding: "0 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "64px",
    flexShrink: 0,
  },

  wizardHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },

  wizardHeaderIconBox: {
    background: "#FFBA45",
    borderRadius: "9px",
    width: "36px",
    height: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },

  wizardHeaderTitle: {
    color: "#ffffff",
    fontWeight: 700,
    fontSize: "15px",
    fontFamily: "Inter",
    lineHeight: 1.3,
    margin: 0,
  },

  wizardHeaderSubtitle: {
    color: "#9ca3af",
    fontSize: "13px",
    fontFamily: "Inter",
    lineHeight: 1.4,
    margin: 0,
  },

  wizardHeaderCloseBtn: {
    background: "rgba(255,255,255,0.08)",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    padding: "6px",
    borderRadius: "6px",
    color: "#fff",
    lineHeight: 1,
    "&:hover": {
      background: "rgba(255,255,255,0.14)",
    },
  },
}));

const STEPS = ["provider", "payer", "client", "preferences", "review"];

const STEP_LABELS = {
  provider: "Provider",
  payer: "Payer",
  client: "Client",
  preferences: "Preferences",
  review: "Review & Activate",
};

const STEP_TITLES = {
  provider: "First, add a provider you want to bill for",
  payer: "Next, connect the payers to be billed",
  client: "Finally, verify client eligibility",
  preferences: "Set your billing preferences",
  review: "Review & Activate",
};

const STEP_DESCS = {
  provider: "Add the legal entities or individuals that you need to submit claims for. You can add as many providers as you bill for.",
  payer: "Add the insurance companies you want to submit claims to. We'll auto-enroll you with each payer.",
  client: "Add information required for billing, verify eligibility and review results before submitting your first claim.",
  preferences: "Defaults applied to every new claim. You can override these on individual claims, or change them later from Billing › Settings › Claim preferences.",
  review: "All set! Review your selections and activate Billing!",
};

const BillingClaimForm = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const { profile, saveProfileLoading } = useSelector((state) => state?.profile);

  const [activeStep, setActiveStep] = useState("provider");
  const [currentPage, setCurrentPage] = useState(1);
  const [scrolled, setScrolled] = useState(false);

  const [prefs, setPrefs] = useState({
    claimFormat: "professional",
    autoEvv: "yes",
    autoEnrollEpa: true,
    eligibilityCheck: true,
    autoBillingNotes: false,
    autoPollStatus: true,
    emailOnRejection: true,
    manualOverride: true,
  });

  // Drawer state (AddProvider/AddPayer/AddClient use state/setState pattern)
  const [drawerState, setDrawerState] = useState({
    addProvider: false,
    addClient: false,
    addPayer: false,
  });

  // Edit/View state
  const [editprovider, setEditProvider] = useState(false);
  const [EditPayerModalOpen, setEditPayerModalOpen] = useState(false);
  const [editclient, setEditClient] = useState(false);
  const [provideritem, setProvideritem] = useState(null);
  const [payeritem, setPayeritem] = useState(null);
  const [clientitem, setClientitem] = useState(null);
  const [view, setView] = useState(false);
  const [providerEnrollment, setProviderEnrollment] = useState(false);
  const [eligibilityModalOpen, setEligibilityModalOpen] = useState(false);

  // Search
  const [providerSearch, setProviderSearch] = useState("");
  const [payerSearch, setPayerSearch] = useState("");
  const [selectedPayer, setSelectedPayer] = useState(null);

  const { loading, allbillingprovider } = useSelector((state) => state.billingprovider);
  const { allpayer } = useSelector((state) => state.payer);
  const { patients } = useSelector((state) => state.patient);

  useEffect(() => {
    if (profile?.user?.billingPreferences) {
      const bp = profile.user.billingPreferences;
      setPrefs((p) => ({
        ...p,
        claimFormat: bp.claimFormat || p.claimFormat,
        autoEvv: bp.autoEvv || p.autoEvv,
        autoEnrollEpa: bp.autoEnrollEpa ?? p.autoEnrollEpa,
        eligibilityCheck: bp.eligibilityCheck ?? p.eligibilityCheck,
        autoBillingNotes: bp.autoBillingNotes ?? p.autoBillingNotes,
        autoPollStatus: bp.autoPollStatus ?? p.autoPollStatus,
        emailOnRejection: bp.emailOnRejection ?? p.emailOnRejection,
        manualOverride: bp.manualOverride ?? p.manualOverride,
      }));
    }
  }, [profile]);

  useEffect(() => {
    if (activeStep === "provider") getBillingProvider({ page: currentPage });
    if (activeStep === "payer") getpayer({ page: currentPage });
    if (activeStep === "client") {
      getAllPatients("all", true, true);
      getBillingProvider({ page: 1 });
      getpayer({ page: 1 });
    }
  }, [activeStep, currentPage]);

  const handlePageChange = (page) => setCurrentPage(page);

  const goNext = async () => {
    if (activeStep === "provider" && !(allbillingprovider?.billingprovider?.length > 0)) {
      await swal({ title: "Add a provider", text: "Please add at least one provider before continuing.", icon: "warning", dangerMode: true });
      return;
    }
    if (activeStep === "payer" && !(allpayer?.payer?.length > 0)) {
      await swal({ title: "Add a payer", text: "Please add at least one payer before continuing.", icon: "warning", dangerMode: true });
      return;
    }
    if (activeStep === "client" && !(patients?.patients?.length > 0)) {
      await swal({ title: "Add a client", text: "Please add at least one client before continuing.", icon: "warning", dangerMode: true });
      return;
    }
    const idx = STEPS.indexOf(activeStep);
    if (idx < STEPS.length - 1) {
      setActiveStep(STEPS[idx + 1]);
      setCurrentPage(1);
    }
  };

  const handleActivateBilling = async () => {
    await updateProfile({ billingPreferences: prefs });
    await getProfile();
    navigate("/home/billing");
  };

  const goBack = () => {
    const idx = STEPS.indexOf(activeStep);
    if (idx > 0) {
      setActiveStep(STEPS[idx - 1]);
      setCurrentPage(1);
    } else {
      navigate("/home/billing");
    }
  };

  const handleEditProvider = (item, isView) => {
    setView(isView);
    setProvideritem(item);
    setEditProvider(true);
  };

  const handleEditPayer = (item, isView) => {
    setView(isView);
    setPayeritem(item);
    setEditPayerModalOpen(true);
  };

  const handleEditClient = (item, isView) => {
    setView(isView);
    setClientitem(item);
    setEditClient(true);
  };

  const handleRemoveProvider = async (id) => {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) removeProvider({ id });
  };

  const handleRemovePayer = async (id) => {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) removepayer({ id });
  };

  const handleSearchProvider = async (val) => {
    try { await getBillingProvider({ name: val, page: 1 }); } catch (e) {}
  };

  const handleSearchPayer = async (val) => {
    try { await getpayer({ name: val, page: 1 }); } catch (e) {}
  };

  const handleAddPayerFromSearch = async (payerResult) => {
    try {
      const payload = {
        values: {
          payerName: payerResult.payer_name,
          payerId: payerResult.payerid,
          payerState: payerResult.payer_state || "AZ",
          payerCity: "Phoenix",
          payerZip: "86052",
          payerAddress1: "1 2 3 street",
        },
        createdBy: profile.user.id,
        admin: profile?.user?.admin ?? profile?.user?.id,
      };
      const res = await createpayer(payload);
      if (res.status === 200) {
        setSelectedPayer(null);
        getpayer({ page: 1 });
        swal({ title: "Payer added successfully", dangerMode: false });
      }
    } catch (e) {
      console.log(e);
    }
  };

  const renderStepNav = () => (
    <Box className={classes.selectbox}>
      <Box className={classes.insidebox}>
        {STEPS.map((step, idx) => {
          const isCurrent = activeStep === step;
          const isDone = STEPS.indexOf(activeStep) > idx;
          const prevIsDone = idx > 0 ? STEPS.indexOf(activeStep) > idx - 1 : false;
          return (
            <React.Fragment key={step}>
              {idx > 0 && (
                <Box className={`${classes.stepSep} ${prevIsDone ? classes.stepSepDone : ""}`} />
              )}
              <Box
                className={classes.iconbox}
                onClick={() => { if (isDone || isCurrent) setActiveStep(step); }}
              >
                <Box
                  component="span"
                  className={`${classes.stepNum} ${isDone ? classes.stepNumDone : ""} ${isCurrent && !isDone ? classes.stepNumCurrent : ""}`}
                >
                  {idx + 1}
                </Box>
                <Text
                  component="span"
                  className={`${classes.stepLabel} ${isDone ? classes.stepLabelDone : ""} ${isCurrent ? classes.stepLabelCurrent : ""}`}
                >
                  {STEP_LABELS[step]}
                </Text>
              </Box>
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );

  const renderProviders = () => (
    <>
      <Box className={classes.payerAddBar}>
        <Box className={classes.flexFill}>
          <BillingSearchAll
            placeholder="Search providers you've added"
            onChange={handleSearchProvider}
            value={providerSearch}
            setValue={setProviderSearch}
          />
        </Box>
        <Box
          component="button"
          className={classes.addAccentBtn}
          onClick={() => setDrawerState({ ...drawerState, addProvider: true })}
        >
          <IconPlus size={16} /> Add Provider
        </Box>
      </Box>

      {loading ? (
        <TableLoader />
      ) : (
        <Box className={classes.wizardCard}>
          <Box className={classes.wizardCardHeadRow}>
            <Box>
              <h3 className={classes.wizardCardTitle}>Your providers</h3>
              <p className={classes.wizardCardMeta}>{allbillingprovider?.count || 0} provider(s) added</p>
            </Box>
          </Box>
          {allbillingprovider?.billingprovider?.length > 0 ? (
            <Box className={classes.payerList}>
              {allbillingprovider.billingprovider.map((item) => {
                console.log("🚀 ~ renderProviders ~ item:", item)
                const isIncomplete =
                  !item?.name || !item?.address || !item?.phone ||
                  !item?.zipcode || !item?.federalTaxID || !item?.billingIdentifier ||
                  !item?.taxonomy || !item?.serviceCode || !item?.state ||
                  !item?.city || !item?.services?.length || !item?.providerEnrollment;

                return (
                  <Box key={item?.id} className={classes.payerRow}>
                    <Box className={classes.payerRowInfo}>
                      <Box className={classes.payerTitleRow}>
                        <h5 className={classes.payerRowH5}>
                          {item?.name || "-"}
                        </h5>
                        <span className={classes.statusInline}>{item?.providertype || "-"}</span>
                      </Box>
                      <p className={classes.payerRowP}>
                        {[
                          (() => { const bi = item?.billingIdentifier; const n = bi ? (typeof bi === "object" ? bi?.number || "" : bi) : ""; return n ? `NPI ${n}` : null; })(),
                          item?.federalTaxID?.number ? `Tax ID ${item.federalTaxID.number}${item.federalTaxID.type ? ` (${item.federalTaxID.type})` : ""}` : null,
                          item?.taxonomy ? `Taxonomy ${item.taxonomy}` : null,
                          item?.serviceCode?.name || null,
                        ].filter(Boolean).join(" · ")}
                      </p>
                      <p className={classes.payerRowP}>
                        {[item?.address, item?.city && item?.state ? `${item.city} ${item.state} ${item.zipcode}` : null, item?.phone, item?.services?.length ? `${item.services.length} services` : null].filter(Boolean).join(" · ")}
                      </p>
                    </Box>
                    <Box className={classes.payerRowActions}>
                      {item?.providerEnrollment === true ? (
                        <Box component="button" className={`${classes.payerAction} ${classes.enrolledDisabled}`} disabled>
                          Enrolled
                        </Box>
                      ) : (
                        <Box component="button" className={classes.payerActionPrimary} onClick={() => { setProvideritem(item); setProviderEnrollment(true); }}>
                          Enroll ERA
                        </Box>
                      )}
                      <Box component="button" className={classes.payerAction} onClick={() => handleEditProvider(item, false)}>Edit</Box>
                      <Box component="button" className={classes.payerDeleteBtn} onClick={() => handleRemoveProvider(item?.id)}>
                        <IconTrash size={15} />
                      </Box>
                    </Box>
                  </Box>
                );
              })}
            </Box>
          ) : (
            <Box className={classes.emptyBox}>
              <RecordNotFound />
              <Center><p className={classes.notFoundText}>No providers added yet</p></Center>
            </Box>
          )}
          <Center>
            <CustomBillingPagination
              data={allbillingprovider?.count}
              itemsPerPage={10}
              currentPage={currentPage}
              handlePageChange={handlePageChange}
            />
          </Center>
        </Box>
      )}
    </>
  );

  const renderPayers = () => (
    <>
      <Box className={classes.tipBanner}>
        <IconBulb size={16} className={classes.tipIcon} />
        <span>
          <strong>Tip:</strong> We recommend adding and enrolling your most frequently used payers now. You can always add more later from <em>Billing › Settings › Payers</em>.
        </span>
      </Box>
      <Box className={classes.payerAddBar}>
        <Box className={classes.flexFill}>
          <BillingSearchAll
            placeholder="Search to add a new payer (Aetna, BCBS, Medicaid, UnitedHealthcare, ...)"
            onChange={handleSearchPayer}
            value={payerSearch}
            setValue={setPayerSearch}
          />
        </Box>
        <Box component="button" className={classes.addAccentBtn} onClick={() => setDrawerState({ ...drawerState, addPayer: true })}>
          <IconPlus size={16} /> Add Payer
        </Box>
      </Box>

      {selectedPayer && (
        <Box className={`${classes.wizardCard} ${classes.wizardCardSpaced}`}>
          <Table highlightOnHover className={`${classes.tableRoot} ${classes.tableInterFont}`} fontSize="sm" verticalSpacing="md">
            <thead>
              <tr>
                <th className={classes.header}>Payer Name</th>
                <th className={classes.header}>Payer ID</th>
                <th className={classes.header}>State</th>
                <th className={classes.header}>Type</th>
                <th className={classes.header}>Add</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={classes.row}>{selectedPayer.payer_name || "-"}</td>
                <td className={classes.row}>{selectedPayer.payerid || "-"}</td>
                <td className={classes.row}>{selectedPayer.payer_state || "-"}</td>
                <td className={classes.row}>{selectedPayer.payer_type || "-"}</td>
                <td className={classes.row}>
                  <Button onClick={() => handleAddPayerFromSearch(selectedPayer)} variant="default" c="#1D2939" bg="#F9FAFB" radius={8} size="md">
                    Add
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
        </Box>
      )}

      <Box className={classes.wizardCard}>
        <Box className={classes.wizardCardHeadRow}>
          <Box>
            <h3 className={classes.wizardCardTitle}>Your payers</h3>
            <p className={classes.wizardCardMeta}>{allpayer?.count || 0} payer(s) added</p>
          </Box>
        </Box>
        {allpayer?.payer?.length > 0 ? (
          <Box className={classes.payerList}>
            {allpayer.payer.map((item, idx) => {
              const addressParts = [item.payerAddress1, item.payerCity, item.payerState, item.payerZip].filter(Boolean);
              const metaParts = [item.payerId ? `Payer ID ${item.payerId}` : null, item.payerEntity || null].filter(Boolean);
              return (
                <Box key={idx} className={classes.payerRow}>
                  <Box className={classes.payerRowInfo}>
                    <Box className={classes.payerTitleRow}>
                      <h5 className={classes.payerRowH5}>
                        {item.payerName || "-"}
                        {(!item?.payerName || !item?.payerId) && (
                          <Tooltip label="Payer Details Incomplete" withArrow position="bottom">
                            <img width={16} src="/assets/images/error.png" alt="warning" />
                          </Tooltip>
                        )}
                      </h5>
                    </Box>
                    {metaParts.length > 0 && (
                      <p className={classes.payerRowP}>
                        {metaParts.join(" · ")}{addressParts.length > 0 ? ` · ${addressParts.join(", ")}` : ""}
                      </p>
                    )}
                  </Box>
                  <Box className={classes.payerRowActions}>
                    <Box component="button" className={classes.payerAction} onClick={() => handleEditPayer(item, true)}>View</Box>
                    <Box component="button" className={classes.payerAction} onClick={() => handleEditPayer(item, false)}>Edit</Box>
                    <Box component="button" className={classes.payerDeleteBtn} onClick={() => handleRemovePayer(item?.id)}>
                      <IconTrash size={15} />
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
        ) : (
          <Box className={classes.emptyBox}>
            <RecordNotFound />
            <Center><p className={classes.notFoundText}>No payers added yet</p></Center>
          </Box>
        )}
        <Center>
          <CustomBillingPagination data={allpayer?.count} itemsPerPage={10} currentPage={currentPage} handlePageChange={handlePageChange} />
        </Center>
      </Box>
    </>
  );

  const renderClients = () => (
    <>
      <Box className={classes.tipBanner}>
        <IconBulb size={16} className={classes.tipIcon} />
        <span>
          <strong>Tip:</strong> You will need an Authorization ID and Authorization Expiration Date for each client. You can always add clients later from <em>Billing › Settings › Clients</em>.
        </span>
      </Box>
      <Box className={classes.wizardCard}>
        <Box className={classes.wizardCardHeadRow}>
          <Box>
            <h3 className={classes.wizardCardTitle}>Your clients</h3>
            <p className={classes.wizardCardMeta}>{patients?.count || 0} client(s)</p>
          </Box>
        </Box>
        <ScrollArea onScrollPositionChange={({ y }) => setScrolled(y !== 0)} className={classes.scrollAreaMin}>
          {patients?.patients?.length > 0 ? (
            patients.patients.map((patient, idx) => {
              const payerInfo = patient?.form2?.BillingInsurance?.[0]?.payer ?? null;
              const authId = patient?.form2?.BillingInsurance?.[0]?.authorization || "-";
              const authExpires = patient?.form2?.BillingInsurance?.[0]?.authorizationEndDate
                ? new Date(patient.form2.BillingInsurance[0].authorizationEndDate).toLocaleDateString("en-US")
                : "-";
              return (
                <Box key={idx} className={classes.clientRow}>
                  <Box className={classes.clientRowInfo}>
                    <Box className={classes.clientTitleRow}>
                      <h5>{patient?.name || "-"}</h5>
                      {payerInfo?.name && <span className={classes.linkedPayerTag}>Linked to Payer</span>}
                    </Box>
                    <p className={classes.clientMeta}>
                      {patient.form1?.dob ? `DOB ${new Date(patient.form1.dob).toLocaleDateString("en-US")}` : "DOB -"} · {patient.form1?.gender || "-"}
                    </p>
                    {payerInfo && (
                      <Box className={classes.clientPayerInfo}>
                        <span className={classes.clientFieldChip}>
                          <span className={classes.clientFieldChipKey}>Auth ID</span>
                          <span className={classes.clientFieldChipVal}>{authId}</span>
                        </span>
                        <span className={classes.clientFieldChip}>
                          <span className={classes.clientFieldChipKey}>Auth Expires</span>
                          <span className={classes.clientFieldChipVal}>{authExpires}</span>
                        </span>
                        <span className={classes.clientFieldChip}>
                          <span className={classes.clientFieldChipKey}>Payer</span>
                          <span className={classes.clientFieldChipVal}>{payerInfo?.name || "-"}</span>
                        </span>
                      </Box>
                    )}
                  </Box>
                  <Box className={classes.clientRowActions}>
                    {payerInfo ? (
                      prefs.eligibilityCheck ? (
                        <Box component="button" className={classes.verifyEligBtn} onClick={() => setEligibilityModalOpen(true)}>
                          Verify Eligibility
                        </Box>
                      ) : null
                    ) : (
                      <Box component="button" className={classes.linkBtnPurple} onClick={() => handleEditClient(patient, false)}>
                        Link to Payer
                      </Box>
                    )}
                  </Box>
                </Box>
              );
            })
          ) : (
            <Box className={classes.emptyBox}>
              <RecordNotFound />
              <Center><p className={classes.notFoundText}>No clients added yet</p></Center>
            </Box>
          )}
        </ScrollArea>
        <Center>
          <CustomBillingPagination data={patients?.count} itemsPerPage={10} currentPage={currentPage} handlePageChange={handlePageChange} />
        </Center>
      </Box>
    </>
  );

  const renderPreferences = () => (
    <Box className={classes.wizardCard}>
      <h6 className={classes.prefSectionLabel}>Default claim type</h6>
      <div className={classes.prefFormGrid}>
        <div className={classes.prefField}>
          <label className={classes.prefFieldLabel}>Default claim format</label>
          <Select
            value={prefs.claimFormat}
            disabled
            onChange={(v) => setPrefs((p) => ({ ...p, claimFormat: v }))}
            data={[
              { value: "professional", label: "Professional (CMS-1500)" },
              { value: "institutional", label: "Institutional (UB-04)" },
            ]}
            classNames={{ input: classes.prefSelectInput, wrapper: classes.prefSelectWrapper }}
            rightSection={<BiChevronDown size={18} className={classes.prefSelectChevron} />}
            rightSectionWidth={28}
            styles={{ rightSection: { pointerEvents: "none" } }}
          />
        </div>
        <div className={classes.prefField}>
          <label className={classes.prefFieldLabel}>Auto-attach EVV visit data</label>
          <Select
            value={prefs.autoEvv}
            disabled
            onChange={(v) => setPrefs((p) => ({ ...p, autoEvv: v }))}
            data={[
              { value: "yes", label: "Yes — always attach" },
              { value: "no", label: "No — attach manually" },
            ]}
            classNames={{ input: classes.prefSelectInput, wrapper: classes.prefSelectWrapper }}
            rightSection={<BiChevronDown size={18} className={classes.prefSelectChevron} />}
            rightSectionWidth={28}
            styles={{ rightSection: { pointerEvents: "none" } }}
          />
        </div>
      </div>
      <h6 className={classes.prefSectionLabelSpaced}>Submission behavior</h6>
      {[
        { key: "autoEnrollEpa", title: "Auto-Enroll in EPA", desc: "Automatically enroll qualifying claims in Electronic Prior Authorization with the payer when the service requires it." },
        { key: "eligibilityCheck", title: "Run eligibility check before submission", desc: "Block submission if the client's eligibility is stale (older than 30 days) or marked ineligible." },
        { key: "autoBillingNotes", title: "Use billing progress notes automatically", desc: "When a Billing Services note exists for the period, pull its service units into the claim." },
        { key: "autoPollStatus", title: "Auto-poll claim status", desc: "Check the clearinghouse every hour for status updates on submitted claims." },
        { key: "emailOnRejection", title: "Email me when a claim is rejected", desc: "Sends an email to the admin within 5 minutes of any rejection." },
        { key: "manualOverride", title: "Allow manual billing override", desc: 'Show "Manual Billing" mode where service units can be entered by hand instead of pulled from notes.' },
      ].map((row) => (
        <div key={row.key} className={classes.prefRow}>
          <div className={classes.prefRowInfo}>
            <p className={classes.prefRowTitle}>{row.title}</p>
            <p className={classes.prefRowDesc}>{row.desc}</p>
          </div>
          <Switch
            checked={!!prefs[row.key]}
            onChange={(e) => { const v = e.currentTarget.checked; setPrefs((p) => ({ ...p, [row.key]: v })); }}
            size="md"
            classNames={{ root: classes.prefSwitchRoot, track: classes.prefSwitchTrack, thumb: classes.prefSwitchThumb }}
          />
        </div>
      ))}
    </Box>
  );

  const renderReview = () => {
    const firstProvider = allbillingprovider?.billingprovider?.[0];
    const firstPayer = allpayer?.payer?.[0];
    const termsDate = profile?.admin?.billingAgreeDate
      ? new Date(profile.admin.billingAgreeDate).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
      : "—";
    const serviceCodes = firstProvider?.services?.length
      ? `${firstProvider.services.length} (${firstProvider.services.map((s) => s?.servicenumber || s?.servicetitle || "").filter(Boolean).join(", ")})`
      : "—";

    return (
      <Box className={classes.reviewClaim}>
        <div className={classes.reviewHead}>
          <div className="review-left">
            <h3>{firstProvider?.name || profile?.admin?.name || "—"}</h3>
            <p>{allbillingprovider?.count || 0} provider(s) · {allpayer?.count || 0} payer(s)</p>
          </div>
          <div className="review-right">
            <div className="rlabel">Clients enrolled</div>
            <div className="rval">{patients?.count || 0}</div>
            <div className="rmeta">{patients?.patients?.filter((p) => p?.form2?.BillingInsurance?.[0]?.payer)?.length || 0} linked to payer</div>
          </div>
        </div>

        <div className={classes.reviewMetaRow}>
          <div className="kv">
            <div className="k">Billing provider</div>
            <div className="v">
              {firstProvider?.name || "—"}
              {(() => { const bi = firstProvider?.billingIdentifier; const n = bi ? (typeof bi === "object" ? bi?.number || "" : bi) : ""; return n ? ` · NPI ${n}` : ""; })()}
            </div>
          </div>
          <div className="kv">
            <div className="k">Tax ID</div>
            <div className="v">
              {firstProvider?.federalTaxID?.number
                ? `${firstProvider.federalTaxID.number}${firstProvider.federalTaxID.type ? ` (${firstProvider.federalTaxID.type})` : ""}`
                : "—"}
            </div>
          </div>
          <div className="kv">
            <div className="k">Default payer</div>
            <div className="v">
              {firstPayer?.payerName || "—"}
              {firstPayer?.payerId ? ` · ${firstPayer.payerId}` : ""}
            </div>
          </div>
          <div className="kv">
            <div className="k">Service codes loaded</div>
            <div className="v">{serviceCodes}</div>
          </div>
          <div className="kv">
            <div className="k">Terms accepted</div>
            <div className="v">{termsDate} · {profile?.user?.name || profile?.admin?.name || "—"}</div>
          </div>
        </div>

        {patients?.patients?.length > 0 && (
          <div className={classes.reviewClients}>
            <h6 className="clients-heading">{patients.count || 0} clients enrolled in billing</h6>
            {patients.patients.map((patient, idx) => {
              const services = patient?.form1?.services?.length || 0;
              const eligibility = patient?.form2?.BillingInsurance?.[0]?.eligibilityStatus || "Verification needed";
              return (
                <div key={idx} className={classes.reviewClientRow}>
                  <div>
                    <div className="label">Client name</div>
                    <div className="v">{patient?.name || "—"}</div>
                  </div>
                  <div>
                    <div className="label">Services</div>
                    <div className="v">{services}</div>
                  </div>
                  <div>
                    <div className="label">Eligibility</div>
                    <div className="v">{eligibility}</div>
                  </div>
                  <button className={classes.reviewViewBtn} onClick={() => handleEditClient(patient, true)}>View</button>
                </div>
              );
            })}
          </div>
        )}
      </Box>
    );
  };

  return (
    <>
      <Box className={classes.wizardOverlay}>
        {/* Wizard header — sticky */}
        <Box className={classes.wizardHeaderBar}>
          <Box className={classes.wizardHeaderLeft}>
            <Box className={classes.wizardHeaderIconBox}>
              <IconCreditCard size={20} color="#1f2937" />
            </Box>
            <div>
              <p className={classes.wizardHeaderTitle}>Billing setup</p>
              <p className={classes.wizardHeaderSubtitle}>
                Get your billing module ready in about 5 minutes
              </p>
            </div>
          </Box>
          <Box
            component="button"
            className={classes.wizardHeaderCloseBtn}
            onClick={() => navigate('/home')}
          >
            <IoCloseOutline size={26} />
          </Box>
        </Box>

        {/* Step nav — sticky below header */}
        {renderStepNav()}

        {/* Scrollable body */}
        <div className={classes.mainbillingcontainer}>
          <div className={classes.wizardContent}>
            <Box className={classes.suggestionbox}>
              <h2 className={classes.wizardStepTitle}>{STEP_TITLES[activeStep]}</h2>
              <p className={classes.wizardStepDesc}>{STEP_DESCS[activeStep]}</p>
            </Box>

            {activeStep === "provider" && renderProviders()}
            {activeStep === "payer" && renderPayers()}
            {activeStep === "client" && renderClients()}
            {activeStep === "preferences" && renderPreferences()}
            {activeStep === "review" && renderReview()}
          </div>
        </div>

        {/* Footer — sticky at bottom */}
        <Box className={classes.wizardFooter}>
          <Text className={classes.wizardFooterNote}>Your progress is saved automatically</Text>
          <Box className={classes.wizardFooterRight}>
            <Box component="button" className={classes.backBtn} onClick={goBack}>Back</Box>
            {activeStep !== "review" ? (
              <Button
                onClick={goNext}
                variant="filled"
                c="#000"
                radius="md"
                size="md"
                color="yellow"
              >
                Continue
              </Button>
            ) : (
              <Button
                onClick={handleActivateBilling}
                variant="filled"
                c="#000"
                radius="md"
                size="md"
                color="yellow"
                loading={saveProfileLoading}
                loaderPosition="right"
              >
                Activate Billing
              </Button>
            )}
          </Box>
        </Box>
      </Box>

      <AddProvider state={drawerState} setState={setDrawerState} onSaved={() => setCurrentPage(1)} />
      <AddPayer state={drawerState} setState={setDrawerState} onSaved={() => setCurrentPage(1)} />
      <AddClient state={drawerState} setState={setDrawerState} payerclient={[]} selectedProvider={null} onSaved={() => setCurrentPage(1)} />

      <EditProvider
        editprovider={editprovider}
        setEditProvider={setEditProvider}
        item={provideritem}
        isPreview={view}
        onSaved={() => setCurrentPage(1)}
      />
      <EditPayer
        EditPayerModalOpen={EditPayerModalOpen}
        setEditPayerModalOpen={setEditPayerModalOpen}
        item={payeritem}
        isPreview={view}
        onSaved={() => setCurrentPage(1)}
      />
      <EditClient
        editclient={editclient}
        setEditclient={setEditClient}
        patient={clientitem}
        isPreview={view}
        selectedProvider={null}
        onSaved={() => setCurrentPage(1)}
      />

      <ProviderEnrollment
        EditProviderEnrollmentModalOpen={providerEnrollment}
        setEditProviderEnrollmentrModalOpen={setProviderEnrollment}
        item={provideritem}
      />
      <VerifyEligibilityModal
        opened={eligibilityModalOpen}
        onClose={() => setEligibilityModalOpen(false)}
      />
    </>
  );
};

export default BillingClaimForm;
